import { PermissionsGuard } from '@akebono/core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProtectedGuard } from 'ngx-auth';
import { PERMISSION_LOTS } from 'src/app/const';

import { LayoutComponent } from '../../components/layout/layout.component';
import { AraiKenkiLotComponent } from './components/arai-kenki-lot/arai-kenki-lot.component';
import { AraiKenkiLotsListComponent } from './components/arai-kenki-lots-list/arai-kenki-lots-list.component';

const routes: Routes = [
  {
    path: 'manual-lots',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: AraiKenkiLotsListComponent,
        canActivate: [PermissionsGuard, ProtectedGuard],
        data: {
          permissions: [PERMISSION_LOTS],
          breadcrumb: 'Lots',
        },
      },
      {
        path: 'lot/:type/:lot',
        component: AraiKenkiLotComponent,
        canActivate: [PermissionsGuard, ProtectedGuard],
        data: {
          permissions: [PERMISSION_LOTS],
          breadcrumb: 'Lot',
        },
      },
      {
        path: 'lot/:source/:lot',
        component: AraiKenkiLotComponent,
        canActivate: [PermissionsGuard, ProtectedGuard],
        data: {
          permissions: [PERMISSION_LOTS],
          breadcrumb: 'Lot',
        },
      },
    ],
    canActivate: [PermissionsGuard, ProtectedGuard],
    data: {
      permissions: [PERMISSION_LOTS],
      breadcrumb: 'Manual',
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AuctionsAraiKenkiLotsRoutingModule {}
